#import "../flexibleSections/flexibleSections.graphql"
#import "~/graphql/fragments/socialFragment.graphql"

fragment eventOverviewPageContent on eventOverview_Entry {
    title
    description: richTextMinimal
    seo {
        ... socialFragment
    }
    showNewsletterSubscribe
}
